import React, { useState } from "react";
import NavbarAdmin from "../../components/NavbarAdmin";
import UserList from "./UserList";
import CreateUserModal from "./CreateUserModal";
import { Container, Button } from "react-bootstrap";

const AdminDashboard = ({ currentUser }) => {
  const [showCreateModal, setShowCreateModal] = useState(false);

  return (
    <>
      <NavbarAdmin currentUser={currentUser} />

      <Container className="mt-4">
        <div className="d-flex justify-content-between align-items-center">
          <h2>VIP Users</h2>

          <Button variant="primary" onClick={() => setShowCreateModal(true)}>
              + Create VIP User
          </Button>
        </div>

        <UserList />

         {/* Create User Modal */}
        <CreateUserModal 
          show={showCreateModal} 
          onHide={() => setShowCreateModal(false)} 
        />
      </Container>
    </>
  );
};

export default AdminDashboard;
